import React ,{useEffect,useState} from 'react'
import { useMsal } from "@azure/msal-react";
import { api_path } from "../shared";
import Container from "@material-ui/core/Container";
import Grid from "@material-ui/core/Grid";
 export function RequestUserRole() {
  const [getMailContent, setMailContent] = useState("");
  const {accounts } = useMsal();
  useEffect(() => {
    setMailContent("S-CRM | New register from "+ accounts[0]?.username);
    sendMailToApi("New user register from S-CRM", getMailContent, "kornraphat.c@sinologistics.co.th");
  },[]) //run one time only
  return (
    <Container maxWidth="lg" className="center">
    <Grid container alignContent={"center"}>
      <Grid container spacing={2}>
        <Grid item xs={12} sm={12}>
          <div className="h4">Please wait administrator to assign role.</div>
        </Grid>
      </Grid>
    </Grid>
  </Container>


   
  )
}
function sendMailToApi(subjectMail, bodyMail, mailTo) {
  var data = {
    subjectMail: subjectMail,
    bodyMail: bodyMail,
    mailTo: mailTo,
  };
  console.log(data)
  fetch(api_path + "/SEND_EMAIL.php", {
    method: "POST",
    headers: {
      Accept: "application/form-data",
      "Content-Type": "application/json",
    },
    body: JSON.stringify(data),
  })
    .then((res) => res.json())
    .then((result) => {
      if (result["status"] == "200") {
       console.log("send mail success")
      } else {
        console.log("send mail error")
      }
    });
}

export default RequestUserRole